// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"global-error_errorContainer__Hi97x","errorMessage":"global-error_errorMessage__zZPR1","retryButton":"global-error_retryButton__uV_31"};